export enum CostScoreCardDepartmentVariant {
	Details = 'details',
	Overview = 'overview',
}